
import React from 'react';

const Payment = () => {
    return (
        <div>
            <h3>Payment method system comming soon .......</h3>
        </div>
    );
};

export default Payment;